import { useQuery } from '@tanstack/react-query';

import { WarehouseInventoryV2Api } from 'api/warehouseInventoryV2';

const warehouseInventoryV2Api = new WarehouseInventoryV2Api();

export const PALLETS_BY_LOCATION_AND_LOT_QUERY_KEY = 'palletsByLocationAndLot';

/**
 * Fetches pallets for a warehouse location and lot (same data as ViewPalletsModal).
 *
 * @param {Object} [options]
 * @param {number | string} [options.facilityId]
 * @param {number | string} [options.locationId]
 * @param {number | string} [options.lotId]
 * @param {boolean} [options.enabled=true]
 * @returns {import('@tanstack/react-query').UseQueryResult<Array<Record<string, unknown>>, Error>}
 */
export const usePalletsByLocationAndLotQuery = ({ enabled = true, facilityId, locationId, lotId } = {}) => {
    const hasFacilityId = facilityId !== undefined && facilityId !== null && facilityId !== '';
    const hasLocationId = locationId !== undefined && locationId !== null && locationId !== '';
    const hasLotId = lotId !== undefined && lotId !== null && lotId !== '';

    return useQuery({
        queryKey: [PALLETS_BY_LOCATION_AND_LOT_QUERY_KEY, { facilityId, locationId, lotId }],
        enabled: enabled && hasFacilityId && hasLocationId && hasLotId,
        queryFn: async () => {
            const response = await warehouseInventoryV2Api.getPallets(facilityId, [
                { searchBy: 'locationId', searchTerm: locationId },
                { searchBy: 'lotId', searchTerm: lotId },
            ]);

            if (!response?.status) {
                throw new Error(response?.msg ?? 'Failed to fetch pallets');
            }

            return response?.data?.pallets ?? [];
        },
        staleTime: 0,
        gcTime: 5 * 60_000,
    });
};
